export const COLORS1 = [

  '#763DFE',  //Openqube Violeta
  '#FF5A78',  //Coral
  '#FFC800',  //Amarillo
  '#7F5CF5' // Celeste
];

export const COLORS2 = [
  // https://www.color-hex.com/color-palette/71119
  '#FFC800',
  '#FF5A78',
  '#7F5CF5',
  '#C850DC',
  '#50E131',
];

export const MEMES = {
  'Visual Studio Code': 'https://thumbs.gfycat.com/CanineImpracticalAmurminnow-size_restricted.gif',
  'Ethereum': 'https://news.bitcoin.com/wp-content/uploads/2017/12/satoshis-vision-696x611.png',
  'Jira': 'http://elestimulo.com/ub/wp-content/uploads/sites/8/2018/05/Haroldfeature-1100x618.jpg',
  'Detractores': 'http://66.media.tumblr.com/7ff797400ae3a8272cbf10d5c694f6e9/tumblr_inline_nq44uvQcyF1r4j8j1_500.gif',
  '(0, 10]': 'https://media.giphy.com/media/3o6UB5RrlQuMfZp82Y/giphy.gif',
  'Elixir': 'https://i.ytimg.com/vi/Swws8plkjI0/hqdefault.jpg',
  'jQuery': 'https://i.ytimg.com/vi/sWB7toeBk1A/hqdefault.jpg',
}


